module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgZmlsbD0iIzNiNTk5OCIgaGVpZ2h0PSI1MTIiIHJ4PSIxNSUiIHdpZHRoPSI1MTIiLz4KPHBhdGggZD0ibTI4NyA0NTZ2LTI5OWMwLTIxIDYtMzUgMzUtMzVoMzh2LTYzYy03LTEtMjktMy01NS0zLTU0IDAtOTEgMzMtOTEgOTR2MzA2bTE0My0yNTRoLTIwNXY3MmgxOTYiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/facebook.svg
// module id = ./src/images/icons/facebook.svg
// module chunks = 114276838955818